import { CheckCircle2, ArrowRight } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const programFacts = [
  { label: "Niveles", value: "Desde A1 hasta B2" },
  { label: "Modalidad", value: "Presencial" },
  { label: "Duración", value: "Según nivel" },
  { label: "Intensidad horaria", value: "Según modalidad" },
  { label: "Horarios", value: "Según disponibilidad" },
];

const levels = [
  {
    badge: "A1 – A2",
    name: "Básico",
    text: "Desarrolla las bases para comunicarte en situaciones cotidianas y familiares.",
  },
  {
    badge: "B1",
    name: "Intermedio",
    text: "Amplía tu vocabulario, mejora tu fluidez y seguridad al hablar.",
  },
  {
    badge: "B2",
    name: "Intermedio Alto",
    text: "Perfecciona tu inglés para contextos académicos y profesionales, y potencia tu empleabilidad.",
  },
];

export default function Program() {
  return (
    <>
      <section id="programa" className="py-20 lg:py-32 bg-slate-50" data-testid="program-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <img
                src="/imagenes/program.webp"
                alt="Clase de inglés en el Politécnico PIO"
                data-testid="program-image"
                className="rounded-2xl border border-slate-200 shadow-lg shadow-blue-900/5 w-full object-cover aspect-[4/3]"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">El programa</span>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Conoce nuestro programa de inglés
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Nuestro programa está diseñado para que avances paso a paso, con un enfoque práctico
              y comunicativo orientado a tu empleabilidad.
            </p>
            <ul className="mt-8 space-y-4" data-testid="program-facts">
              {programFacts.map((f) => (
                <li key={f.label} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 mt-0.5 shrink-0" />
                  <span className="text-slate-700">
                    <strong className="font-semibold text-slate-900">{f.label}:</strong> {f.value}
                  </span>
                </li>
              ))}
            </ul>
            <a
              href="#contacto"
              data-testid="program-cta-button"
              className="mt-9 inline-flex items-center gap-2 rounded-full bg-slate-900 px-7 py-3.5 text-sm font-semibold text-white hover:bg-slate-800 transition-colors"
            >
              Solicitar información
              <ArrowRight className="w-4 h-4" />
            </a>
          </Reveal>
        </div>
      </section>

      <section id="niveles" className="py-20 lg:py-32 bg-white" data-testid="levels-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">De A1 a B2</span>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Niveles de inglés
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl">
              Enseñamos desde el nivel A1 hasta el B2, según el Marco Común Europeo de Referencia
              para las Lenguas.
            </p>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="levels-grid">
            {levels.map((lvl, i) => (
              <Reveal key={lvl.badge} delay={i * 0.08}>
                <div
                  data-testid={`level-card-${i + 1}`}
                  className="h-full rounded-2xl border border-slate-200 bg-white p-8 transition-transform hover:-translate-y-1 hover:shadow-lg hover:shadow-blue-900/5"
                >
                  <span className="inline-flex rounded-full bg-blue-600/10 px-4 py-1.5 text-sm font-bold text-blue-600 font-heading">
                    {lvl.badge}
                  </span>
                  <h3 className="mt-5 font-heading text-2xl font-semibold text-slate-900">{lvl.name}</h3>
                  <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{lvl.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
